import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Avatar, Card, Col, Flex, Typography, theme } from "antd";
import { useDispatch } from "react-redux";
import { setVideoId } from "./../../../../store/reducers/videoReducer.js";
import VideoPlayButton from "./../../../videoPlayButton/VideoPlayButton.js";
const { Paragraph, Text } = Typography;
const Video = ({ video, videoClickCallback, variant, leagueIconUrl }) => {
  const { token } = theme.useToken();
  const dispatch = useDispatch();
  const isFixture = variant === "fixture";
  const thumbnail = `https://img.youtube.com/vi/${video.externalHostingVideoId}/hqdefault.jpg`;
  const onContainerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (video.type === 0) {
      return window.open(video.publicUrl, "_blank");
    }
    videoClickCallback == null ? void 0 : videoClickCallback();
    dispatch(setVideoId(video.externalHostingVideoId));
  };
  return /* @__PURE__ */ jsx(
    Col,
    {
      xs: 24,
      lg: isFixture ? 24 : 12,
      style: { display: "flex" },
      children: /* @__PURE__ */ jsx(
        Card,
        {
          onClick: onContainerClick,
          hoverable: true,
          style: {
            width: "100%",
            cursor: "pointer",
            border: "none",
            boxShadow: "none",
            padding: isFixture ? 12 : 16,
            backgroundColor: token.colorBgSolid,
            borderRadius: token.borderRadiusSM
          },
          styles: { body: { padding: 0 } },
          cover: /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                position: "relative",
                aspectRatio: "16/9",
                marginBottom: isFixture ? 12 : 16
              },
              children: /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    cursor: "pointer",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url(${thumbnail})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: token.borderRadiusXS,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  children: /* @__PURE__ */ jsx(VideoPlayButton, {})
                }
              )
            }
          ),
          children: isFixture ? /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 8, style: { minWidth: 0 }, children: [
            leagueIconUrl && /* @__PURE__ */ jsx(
              Avatar,
              {
                src: leagueIconUrl,
                size: 24,
                shape: "square",
                style: { flexShrink: 0 }
              }
            ),
            /* @__PURE__ */ jsx(
              Text,
              {
                ellipsis: { tooltip: video.title },
                style: {
                  fontSize: token.fontSizeXS,
                  fontWeight: 700,
                  color: token.colorTextBase,
                  minWidth: 0
                },
                children: video.title
              }
            )
          ] }) : /* @__PURE__ */ jsx(
            Paragraph,
            {
              ellipsis: { rows: 2, tooltip: video.title },
              style: {
                fontWeight: 600,
                color: token.colorTextBase,
                marginBottom: 0,
                overflowWrap: "anywhere"
              },
              children: video.title
            }
          )
        }
      )
    },
    video.externalHostingVideoId
  );
};
var stdin_default = memo(Video);
export {
  stdin_default as default
};
